import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  HostListener,
  ViewChild,
  Renderer2,
  AfterViewChecked,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FinishProService } from '../../services/finish-pro.service';
import { MatDialog } from '@angular/material/dialog';
import {
  IvCertCircuitDocumentP,
  MetadataOperation,
  OperationService,
  RegisterConditions,
  UserService,
} from '../../../api';
import { AvailableOperationTypes } from '../../models/operations/available-operation-types';
import { Routes } from '../../models/routes';
import { LoadingProService } from '../../services/loading-pro.service';
import { Subscription } from 'rxjs';
import { DocumentListObserve } from '../../models/operations/document-list-observe';
import { LocationService } from '../../services/location.service';
import { CustomMetadataOperation } from '../../models/operations/metadata';
import { WidgetSettings } from '../../models/documents/documents';
import { PersonalizationsService } from '../../../base/services/personalizations/personalizations.service';
import { ProfileService } from '../../../core/profile/profile.service';
import { Environment } from '../../../models/environment';
import { LanguageService } from '../../services/language.service';
import { DynamicSignatureModalComponent } from '../../components/modal/dynamic-signature-modal/dynamic-signature-modal.component';
import { DialogCustomFieldsComponent } from '../../../shared/dialog/signaturit/dialog-custom-fields/dialog-custom-fields.component';
import { ConfirmModalComponent } from '../../components/modal/confirm-modal/confirm-modal.component';
import { WidgetPosition } from './types/document-viewer-types';
import { FinishEventResult } from '../../../finish/models/finish-event-result';
import { IvCertGenericResponseRegisterConditions } from '../../../api/model/ivCertGenericResponseRegisterConditions';
import { DocumentViewerModalComponent } from './modal/document-viewer-modal.component';
import { AccessCodeComponent } from '../access-code/access-code.component';
import { PdfViewerService } from '../../services/pdf-viewer.service';
import { DocumentsHeaderComponent } from '../../components/documents-header/documents-header.component';
import { viewerType } from '../../../finish/models/viewer-type';
import { EncodeB64Service } from '../../../base/services/encode-b64/encode-b64.service';
import { DisplayState } from '../../../shared/enums/signaturit/signaturit-enums';
import { NotificationService } from '../../../base/services/notification/notification-service';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomFiedlsType } from '../../models/pdf-viewer/types';
import { PageCustomAnnotations, PdfDocumentManager, PdfPageManager } from '../../models/pdf-viewer';
import { MessageService } from '../../../shared/message/message.service';
import { codeViewerErrorsEnum } from './enums/document-viewer-enums';
import { TranslateService } from '../../../core/translation';
import { DialogConfirmComponent } from '../../../shared/dialog/dialog-confirm/dialog-confirm.component';

export type InputList = {
  type: string;
  page: number;
  name: string;
  value: string;
  id: string;
  checkbox: boolean;
  radioButton: boolean;
  position: {
    margin: number;
    padding: number;
    top: number;
    left: number;
    height: number;
    width: number;
  };
  readonly: boolean;
  fieldValue: string;
  checked: boolean;
  buttonValue: string;
};

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
  providers: [PdfViewerService],
})
export class DocumentViewerComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('documentsHeader') documentsHeader: DocumentsHeaderComponent;

  documentOperation: IvCertCircuitDocumentP;

  pdfSrcTerms: string = '';

  signaturePadControl: boolean = false;

  signatureCertControl: boolean = false;

  nameDoc: string;

  isOperationFinished: boolean = false;

  isLoadedDoc: boolean = false;

  metadataCert: MetadataOperation[];

  totalPages: number = 1;

  totalPagesLoaded: number = 0;

  isCert: boolean = false;

  idDocument: string;

  private _parentRouteSubscription: Subscription;

  private _routeSubscription: Subscription;

  documentB64: string;

  widgetsettings: WidgetSettings[] = [];

  currentWidgetSelected: string = '';

  operationType: AvailableOperationTypes;

  latitude: number;

  longitude: number;

  initialWidthDocument: number = 1148;

  trueTotalPages: number = 1;

  prevPageBtn: boolean = true;

  nextPageBtn: boolean = false;

  page: number = 1;

  environment: Environment;

  isSinglePage: boolean = false;

  showFooter: boolean = false;

  defaultHeightPage: number = 1626;

  defaultWidthPage: number = 1148;

  ratioHeight: number = 1;

  ratioWidth: number = 1;

  realHeightPage: number = 0;

  realWidthPage: number = 0;

  inputName: string;

  inputList = [];

  inputListByDocument = [];

  metaDataOperation = [];

  templateCode: string = '';

  extension: string = 'PDF';

  xml: string = '';

  date: Date;

  isDynSig: boolean = false;

  customFieldsValue: CustomFiedlsType<string | boolean | Date>[];

  hasSavedCustomFields: boolean = false;

  showLoaderRejectBegin: boolean = false;

  allDocumentsReaded: boolean = false;

  termsAccepted: boolean = false;

  firmaImagen: string = '';

  currentDocument: PdfDocumentManager;

  pageManagerArray: PdfPageManager[] = [];

  pdfPagesSubscription: Subscription;

  viewHasBeenChecked: boolean = false;

  documents: IvCertCircuitDocumentP[];

  pageCustomAnnotations: PageCustomAnnotations[] = [];

  isSignatureReady: boolean = false;

  finishAfterSign: boolean = false;

  notifMessage: string = null;

  selectedDoc: string = '';

  signsSIGBIO = [];

  hasGenerateFormDoc: IvCertCircuitDocumentP;

  hasRequriredCustomFields: boolean = false;

  isPublic: boolean = true;

  maxScroll: number = 0;

  actualScroll: number = 0;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _finishProService: FinishProService,
    private _loadingPro: LoadingProService,
    private _locationService: LocationService,
    private _dialog: MatDialog,
    private _customization: PersonalizationsService,
    private _profile: ProfileService,
    private _user: UserService,
    private _operation: OperationService,
    private _pdfViewerService: PdfViewerService,
    private _renderer: Renderer2,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private _notification: NotificationService,
    private _encoder: EncodeB64Service,
    private _message: MessageService
  ) { }

  ngOnInit(): void {
    this.isPublic = this._finishProService.isPublic;
    this._languageService.subscribeToTranslationChange(this as Component);
    this.pageCustomAnnotations = [];
    this.getConfigTerms();
    this.environment = this._customization.sendEnv;
    this.isSinglePage = this.environment.features.singlePage;
    this.templateCode = this._finishProService.operationDetailResponse?.codeTemplate;
    this.operationType = this._finishProService.operationDetailResponse?.operationType as AvailableOperationTypes;
    this._finishProService.downloadOnFinish = this.environment.features.downloadOnFinish?.[this.operationType];
    this._finishProService.documentsReaded = [];
    this.date = new Date();
    this.getLocation();
    this.checkDocuments();
    this.documents = this._finishProService.documentListResponse?.filter((doc) => doc.type === 1);
    this.hasGenerateFormDoc = this.documents?.find((doc) => doc.generateFormDoc === true);
    this._routeSubscription = this._route.params.subscribe((params) => {
      if (params.documentId) {
        this.resetStateOnRouteChange();
        this.pageCustomAnnotations = [];
        this.inputList = [];
        this.widgetsettings = [];
        this.isLoadedDoc = false;
        this.documentOperation = this._finishProService.documentListResponse?.find(
          (elem) => elem.idDocument === params.documentId
        );
        this.nameDoc = this.documentOperation?.fileNameWithExtension;
        this.extension = this.nameDoc?.split('.').pop().toUpperCase();
        this.idDocument = params.documentId;
        this._finishProService.documentIdSelected = this.idDocument;
        this.setDocument();
        this.cleanWidgets();
      }
    });

    this._parentRouteSubscription = this._route.parent.params.subscribe((params) => {
      if (params.id) {
        this.isLoadedDoc = false;
        if (this.operationType === AvailableOperationTypes.DYNSIG) {
          this.isDynSig = true;
          this._finishProService.isDynSig = true;
          const metadata = this._finishProService.operationDetailResponse?.metadata;
          const operations = metadata?.find((f) => f.key === 'SIG_PREF')?.value;

          const dialog = this._dialog.open(DynamicSignatureModalComponent, {
            width: '30rem',
            data: JSON.parse(operations),
            disableClose: true,
            panelClass: 'dynamic__signature',
          });

          dialog.afterClosed().subscribe((result: { success: boolean; operationType: AvailableOperationTypes }) => {
            if (result?.success) {
              this.operationType = result.operationType;
              this._finishProService.operationDetailResponse.operationType = this.operationType;
              this.handleInitialSetup();
            }
          });
        } else {
          this.handleInitialSetup();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    const mainContent = document.getElementById('main-content');
    if (mainContent && !this.isPublic) {
      mainContent.addEventListener('scroll', () => {
        this.isScrollAtBottomNotPublic();
      });
    }
    this._loadingPro.setNextOperationLoader(false);
    this._languageService?.subscribeToTranslationChange(this.documentsHeader as Component);
  }

  ngAfterViewChecked(): void {
    this.currentDocument = this._pdfViewerService.pdfDocumentManager;

    const isReady = this.isSinglePage
      ? !!this.totalPages && !!this.currentDocument?.proxy
      : this.totalPages === this.currentDocument?.proxy?.numPages;

    if (isReady && !this.viewHasBeenChecked) {
      this.handlePdfRenderingOperations();
    }
  }

  resetStateOnRouteChange(): void {
    if (this._pdfViewerService.hasFinishedRangeRender) {
      this._pdfViewerService.hasFinishedRangeRender.next(false);
    }
    this._pdfViewerService.setCurrentPdfManager(undefined);
    this.pageManagerArray = [];
    this.currentDocument = undefined;
    this.totalPages = 1;
    this.page = 1;
    this.viewHasBeenChecked = false;
    this.pageCustomAnnotations = [];
  }

  async loadPdfJsInstance(documentId: string, pdfBuffer: Uint8Array | string): Promise<void> {
    try {
      await this._pdfViewerService.createPdfDocumentManager(documentId, this._renderer, pdfBuffer);
      const instance = this._pdfViewerService.pdfDocumentManager;
      if (instance) {
        this.totalPages = instance.proxy?.numPages;
        this.afterInstanceComplete(this.totalPages);
      }
    } catch (e) {
      console.log(e);
      throw new Error('Error on loadPdfJsInstance..');
    }
  }

  handlePdfRenderingOperations(): void {
    this.viewHasBeenChecked = true;
    const pagesRange: number[] = this.isSinglePage ? [this.page] : [1];

    this._pdfViewerService.handleOperationsByConfig(pagesRange);
    this.subscribeToPagesAnnotations();

    this._loadingPro.setLoader(false);
  }

  toSortedPages(a: PdfPageManager, b: PdfPageManager): number {
    return a.pageNumber - b.pageNumber;
  }

  handlePageAnnotations(page: PdfPageManager): void {
    const hasCustomAnnotations = page?.customAnnotations.length > 0;
    if (hasCustomAnnotations) {
      this.createInputList(page.customAnnotations);
    }
  }

  handlePageManagerWidgetUpdate(): void {
    this._pdfViewerService.pdfDocumentManager.pageManagerList.forEach((page) => {
      if (!page.hasRenderedWidget) {
        this.renderPageWidgets(page.pageNumber);
        page.hasRenderedWidget = true;
      }
    });
  }

  handlePageManagerAcrobatFields(page): void {
    this.hasRequriredCustomFields = true;
    page._annotations.forEach((annotation, index) => {
      if ((annotation.fieldFlags & 2) !== 0 && !annotation.radioButton) {
        if (!this.inputList[index].value || this.inputList[index].length === 0 || (this.inputList[index].value === 'Off' && this.inputList[index].type === 'checkbox')) {
          this.hasRequriredCustomFields = false;
          this.inputList[index].error = true;
        }
        else {
          this.inputList[index].error = false;
        }
      }
    });
    this.handleGroupRadioFields(this.inputList);
  }

  handlePageManagerAcrobatFieldsStatus(page, indexInput: number): void {
    if ((page._annotations[indexInput]?.fieldFlags & 2) !== 0) {
      if (!this.inputList[indexInput].value || this.inputList[indexInput].length === 0 || (this.inputList[indexInput].value === 'Off' && this.inputList[indexInput].type === 'checkbox')) {
        this.inputList[indexInput].error = true;
      } else {
        this.inputList[indexInput].error = false;
      }
    }
    this.handleGroupRadioFields(this.inputList);
  }


  handleGroupRadioFields(annotations): void {
    let groupsRadioAnnotations = [];
    let groupRadio = [];
    let groupName = '';
    annotations.forEach((annotation) => {
      if ((annotation.type === 'radio') && ((annotation.flags & 2) !== 0)) {
        if (annotation.name === groupName || groupName === '') {
          groupName = annotation.name;
          groupRadio.push(annotation);
        }
        else {
          groupName = groupName
        }
      }
    });
    if (groupRadio.length > 0) {
      groupsRadioAnnotations.push(groupRadio);
      groupRadio = [];
    }
    this.handlePageManagerRadioFields(groupsRadioAnnotations);
  }

  handlePageManagerRadioFields(annotationGroups): void {
    annotationGroups.forEach(annotationGroup => {
      let hasValue = false;
      annotationGroup.forEach(annotation => {
        if (annotation.value) {
          hasValue = true;

        }
      });

      if (!hasValue) {
        annotationGroup.forEach((annotation) => {
          this.inputList.forEach(input => {
            if (input.id === annotation.id) {
              input.error = true;
            }
          })
        })
      }
      else {
        annotationGroup.forEach((annotation) => {
          this.inputList.forEach(input => {
            if (input.id === annotation.id) {
              input.error = false;
            }
          })
        })
      }
    })
  }

  subscribeToPagesAnnotations(): void {
    this.pdfPagesSubscription = this._pdfViewerService.hasFinishedRangeRender.subscribe((hasFinished: boolean) => {
      if (hasFinished) {
        const pdfArr = this._pdfViewerService.pdfDocumentManager.pageManagerList;

        if (this.isSinglePage) {
          this.pageManagerArray = pdfArr;
          this.handlePageAnnotations(pdfArr.find((page) => page.pageNumber === this.page));
          this.renderPageWidgets(this.page);
          return;
        }

        this.pageManagerArray = pdfArr.sort(this.toSortedPages);
        this._pdfViewerService.pdfDocumentManager.pageManagerList.forEach((page) => {
          this.handlePageAnnotations(page);
        });

        this.handlePageManagerWidgetUpdate();
      }
    });
  }

  isPageLoaded(pageIndex: number): boolean {
    return this.pageManagerArray.length > 0 && this.pageManagerArray[pageIndex]?.hasRenderedImage;
  }

  ngOnDestroy(): void {
    const mainContent = document.getElementById('main-content');
    if (mainContent && !this.isPublic) {
      mainContent.removeEventListener('scroll', () => {
        this.isScrollAtBottomNotPublic();
      });
    }
    if (this._parentRouteSubscription) {
      this._parentRouteSubscription.unsubscribe();
    }

    if (this._routeSubscription) {
      this._routeSubscription.unsubscribe();
    }

    this._dialog.closeAll();

    if (this.pdfPagesSubscription) {
      this.pdfPagesSubscription.unsubscribe();
    }
  }

  handleInitialSetup(): void {
    this.getTypeOperation();
    this.isOperationFinished = false;
  }

  cleanWidgets(): void {
    if (this.widgetsettings.length) {
      this.widgetsettings.forEach((widget) => {
        widget.imagePath = '';
        widget.textSignCert = false;
      });
    }
  }

  getTypeOperation(): void {
    if (this.operationType === AvailableOperationTypes.SIG || this.operationType === AvailableOperationTypes.SIGQSCD) {
      this.isCert = true;
    }
  }

  setDocument(): void {
    this.page = 1;
    this.downloadPDF();
    setTimeout(() => {
      this._loadingPro.setNextOperationLoader(false);
      this._loadingPro.getOperationTypeProps(this.operationType);
    }, 2000);
  }

  renderPageWidgets(pageNum: number): void {
    let hasCertificateSelected: boolean = false;
    const operationType = this._finishProService.operationDetailResponse?.operationType;
    const widgetOperation = this._finishProService.operationDetailResponse?.widgetOperation;

    if (
      (operationType === AvailableOperationTypes.SIGBIO ||
        operationType === AvailableOperationTypes.SIG ||
        operationType === AvailableOperationTypes.SIGQSCD) &&
      !widgetOperation.length
    ) {
      hasCertificateSelected = !!this.metadataCert?.length;
    }

    const hasOperationWidget = widgetOperation.length > 0 && !this.widgetsettings[pageNum - 1];

    if (hasOperationWidget) {
      widgetOperation.forEach((widget, index: number) => {
        const isTextPage = widget.page === 'all' || widget.page === 'last';
        const isSpecialConfig = widget.page.includes(',') || widget.page.includes('-');
        const hasToCreateWidget = pageNum.toString() === widget.page || isTextPage || isSpecialConfig;

        if (hasToCreateWidget) {
          const design = JSON.parse(widget.design);
          const pageSelector = this.isSinglePage || isTextPage || isSpecialConfig ? 1 : widget.page;

          const pageWrapper = document?.getElementById(`page-renderer-wrapper-${pageSelector}`);

          const { height, width } = pageWrapper?.getBoundingClientRect();

          const LEFT_ERROR_RANGE = 5;

          const widgetPositions: WidgetPosition = {
            top: !!design?.initialTopPercentage
              ? `${design.initialTopPercentage * height}px`
              : design.positionProTop + 'px',
            left: !!design?.initialLeftPercentage
              ? `${design.initialLeftPercentage * width + LEFT_ERROR_RANGE}px`
              : design.positionProLeft + 'px',
            width: !!design?.relativeWidth ? `${design.relativeWidth * width}px` : design.newWidth + 'px',
            height: !!design?.relativeHeight ? `${design.relativeHeight * height}px` : design.newHeight + 'px',
          };

          const widgetConfig = {
            idWidget: `widget_${index + 1}`,
            pages: [],
            page: widget.type.includes('INITIALS') ? 'all' : widget.page,
            design: widget.design,
            type: widget.type,
            onlyText: design.onlyText,
            initials: design.initials,
            positionX: widget.positionX,
            positionY: widget.positionY,
            isRequired: design.isRequired,
            isEditable: design.isEditable,
            date: design.date,
            textWidget: design.textWidget,
            doc: widget.doc,
            positions: widgetPositions,
            imagePath: this.firmaImagen ? 'data:image/jpg;base64,' + this.firmaImagen : null,
            searchpattern: design.searchpattern,
            textSignCert: hasCertificateSelected,
          };
          this.handleWidgetPagesConfig(widgetConfig);
          this.widgetsettings.push(widgetConfig);
        }
      });
    }
  }

  isRenderingWidget(w: WidgetSettings, i: number): boolean {
    const isCurrentDoc = this.selectedDoc === w.doc;
    const isPageIncluded =
      (w.pages.includes(i + 1) && !this.isSinglePage) || (w.pages.includes(this.page) && this.isSinglePage);
    const isSignatureType = w.type.includes('SIGNATURE') && !w.searchpattern;

    const isRendering = isCurrentDoc && isPageIncluded && isSignatureType;

    return isRendering;
  }

  async downloadPDF(): Promise<void> {
    try {
      await this._finishProService.getDownloadDocumentCircuit(
        DocumentListObserve.RESPONSE,
        this.idDocument,
        false,
        false
      );
      this.extension = this._finishProService.extension;

      if (this.extension === 'PDF') {
        await this.loadPdfJsInstance(this.idDocument, this._finishProService.documentBuffer);
        this.documentB64 = this._encoder.arrayBufferToBase64(this._finishProService.documentBuffer);
      } else if (this.extension === 'XML') {
        this.xml = this._finishProService.xml;
        this.showFooter = true;
      }

      this._loadingPro.setLoader(false);
      this.isLoadedDoc = true;

      if (this.operationType === AvailableOperationTypes.SIG && this._finishProService.tokenSAML) {
        this.signatureCertControl = true;
      }
    } catch (e) {
      this.isLoadedDoc = false;
      throw new Error('Error loading document..');
    }
  }

  handleWidgetPagesConfig(widgetConfig): void {
    if (widgetConfig.page === 'all') {
      for (let i = 0; i <= this.totalPages; i++) {
        widgetConfig.pages.push(i);
      }
    }

    if (widgetConfig.page === 'last') widgetConfig.pages.push(this.totalPages);
    widgetConfig.page = widgetConfig.page.toString();

    const pages = widgetConfig.page.split(',');

    this.addPages(widgetConfig, pages);
    if (!widgetConfig.pages.length) {
      widgetConfig.pages.push(parseInt(widgetConfig.page));
    }
  }

  addPages(widget: WidgetSettings, pages: string[]): void {
    for (const page of pages) {
      if (page.includes('-')) {
        const interval = page.split('-');
        const minInterval = parseInt(interval[0]);
        const maxInterval = parseInt(interval[1]);
        for (let i = minInterval; i <= maxInterval; i++) {
          widget.pages.push(i);
        }
      } else {
        widget.pages.push(parseInt(page));
      }
    }
  }

  async openSignComponent(idWidget: string): Promise<void> {
    const availableOperationsPadControl: AvailableOperationTypes[] = [
      AvailableOperationTypes.ACEP,
      AvailableOperationTypes.SIGBIO,
      AvailableOperationTypes.RVDOTP,
    ];

    const availableOperationsCertControl: AvailableOperationTypes[] = [
      AvailableOperationTypes.SIG,
      AvailableOperationTypes.SIGQSCD,
    ];

    const isOperationAvailablePadControl = availableOperationsPadControl.includes(
      this.operationType as AvailableOperationTypes
    );
    const isOperationAvailableCertControl = availableOperationsCertControl.includes(
      this.operationType as AvailableOperationTypes
    );
    const isDynamicAndBiometricSignature = this.isDynSig && this.operationType === AvailableOperationTypes.SIGBIO;

    if (this._finishProService.operationDetailResponse?.widgetOperation.length > 0) {
      const widget = JSON.parse(this._finishProService.operationDetailResponse?.widgetOperation[0].design);

      if (widget.onlyText && !isOperationAvailableCertControl && !isDynamicAndBiometricSignature) {
        return;
      }
    }

    this.currentWidgetSelected = idWidget;
    if (isOperationAvailableCertControl) {
      this.addOperationMetadata();
      this._finishProService.metaDataOperation = this.metaDataOperation;
      this.signatureCertControl = true;
    }

    if (isOperationAvailablePadControl) {
      this.addOperationMetadata();
      this._finishProService.metaDataOperation = this.metaDataOperation;
      if (this._finishProService.validateFormDoc === 1 && this.hasGenerateFormDoc && !this.isSignatureReady) {
        const isValidForm = await this.validateFormDocumentSuez();
        if (isValidForm) {
          this.signaturePadControl = true;
        }
      }
      else {
        this.signaturePadControl = true;
      }
    }
  }

  closeSignComponent(): void {
    this.signaturePadControl = false;
    this.signatureCertControl = false;
    console.log('SignatureCertControl -> ' + this.signatureCertControl);
  }

  showSignature(sig: string): void {
    const index = this.widgetsettings.findIndex((x) => x.idWidget === this.currentWidgetSelected);
    if (this.widgetsettings[index]) {
      this.widgetsettings[index].imagePath = 'data:image/jpg;base64,' + sig;
    }
    this.firmaImagen = sig;
    this.isSignatureReady = true;

    if (this.finishAfterSign) {
      if (this.operationType === AvailableOperationTypes.ACEP) {
        this.sign();
      }
      if (this.operationType === AvailableOperationTypes.RVDOTP) {
        this.addOperationMetadata();
        this.signOperation();
      }
    }
  }

  getDocSigned(event: any): void {
    this.signsSIGBIO = event;
    this.isSignatureReady = true;
    if (this.finishAfterSign && this.operationType === AvailableOperationTypes.SIGBIO) {
      this.sign();
    }
  }

  afterInstanceComplete(numPages: number): void {
    if (this.isSinglePage) {
      this.totalPages = 1;
      this.page = 1;
      this.trueTotalPages = numPages;
      this.prevPageBtn = this.page > 1 ? false : true;
      this.nextPageBtn = this.trueTotalPages === 1;
    }
    this.showFooter = true;
    this.totalPagesLoaded += 1;

    this.setDocumentAsLoaded();
    if (this._finishProService.readAllDoc === 0) {
      const documentsReaded = this._finishProService.documentsReaded;
      documentsReaded.forEach((doc) => {
        doc.readed = true;
      });
      this.allDocumentsReaded = documentsReaded.every((doc) => doc.readed);
    }
  }


  validatorScroll(): void {
    if (this.isScrollAtBottom() && !this.allDocumentsReaded) {
      this.setDocumentAsReaded();
    }
  }

  validatorSinglePage(): void {
    if (this.page === this.trueTotalPages && this.isScrollAtBottom()) {
      this.setDocumentAsReaded();
    }
  }

  setScroll(): void {
    if (this._finishProService.readAllDoc === 1) {
      if (!this.isSinglePage) {
        this.validatorScroll();
      }
      else {
        this.validatorSinglePage();
      }
    }
  }

  setDocumentAsLoaded(): void {
    const documentsReaded = this._finishProService.documentsReaded;
    documentsReaded.find((doc) => doc.idDocument === this.idDocument).loaded = true;
  }

  setDocumentAsReaded(): void {
    const documentsReaded = this._finishProService.documentsReaded;
    documentsReaded.find((doc) => doc.idDocument === this.idDocument).readed = true;
    this.allDocumentsReaded = documentsReaded.every((doc) => doc.readed);
  }

  @HostListener('document:wheel', ['$event.target'])
  public onWheel(): void {
    this.setScroll();
  }

  @HostListener('document:mouseup', ['$event.target'])
  public onMouseUp(): void {
    this.setScroll();
  }

  isScrollAtBottom(): boolean {
    if (this.isPublic) {
      const scrollPosition = window.scrollY + window.innerHeight;
      const footer = document.getElementById('viewerFooter');
      const documentHeight = document.documentElement.scrollHeight - footer?.offsetHeight;

      if (scrollPosition >= documentHeight) {
        this.setDocumentAsReaded();
      }
      return scrollPosition >= documentHeight;
    }
    else {
      return this.isScrollAtBottomNotPublic();
    }
  }

  isScrollAtBottomNotPublic(): boolean {
    const footer = document.getElementById('viewerFooter');
    const scrollHeight = document.getElementById('main-content').scrollTop;
    const scrollMax = document.getElementById('main-content').scrollHeight - 15;
    const width = document.getElementById('main-content').offsetHeight;
    const total = scrollHeight + width;

    if (total >= scrollMax - footer?.offsetHeight) {
      this.setDocumentAsReaded();
      return true;
    }
    else {
      return false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.isScrollAtBottom();
  }

  getMetadataCert(sig?: FinishEventResult): void {
    if (this.widgetsettings.length) {
      for (let wid of this.widgetsettings) {
        wid.textSignCert = true;
      }
    }

    const certificateSignatures: AvailableOperationTypes[] = [
      AvailableOperationTypes.SIG,
      AvailableOperationTypes.SIGQSCD,
    ];

    if (certificateSignatures.includes(this.operationType)) {
      this.metadataCert = sig?.metadata;

      if (this.finishAfterSign) {
        this.isSignatureReady = true;
        this.sign();
      }
    }
  }

  addOperationMetadata(): void {
    this.metaDataOperation = this.getOperationMetadata();

    if (this.inputListByDocument?.length > 0) {
      for (let i = 0; i < this.inputListByDocument.length; i++) {
        const data = this.inputListByDocument[i].data;
        data?.forEach((input) => {
          const metadata = { key: input.name, value: input.value || '' };
          if (input.type === 'radio' && input.value) {
            metadata.value = input.buttonValue;
          }
          if (this.hasMetadataValue(metadata.value)) {
            this.metaDataOperation.push(metadata);
          }
        });
      }
    }

    this.metaDataOperation.forEach((metadata) => {
      if (metadata.key.includes('___')) {
        metadata.key.replace('___', '.');
      }
    });
  }

  getOperationMetadata(): CustomMetadataOperation[] {
    const metadata: CustomMetadataOperation[] = [];

    if (this._finishProService.operationRequest.hasCustomCheckbox) {
      const customCheckbox = this._finishProService.operationDetailResponse.CheckBoxConsent;
      for (let i = 0; i < customCheckbox.length; i++) {
        metadata.push({ key: 'checkBoxConsentSign', value: customCheckbox[i].Key });
      }
    }

    metadata.push({ key: 'privacyPolicyAccepted', value: true });

    this.widgetsettings?.forEach((wid) => {
      if (wid.design) {
        const design = JSON.parse(wid.design);

        if (wid.type.includes('TEXT') || wid.type.includes('INITIALS')) {
          metadata.push({ key: design.widget_fieldID.toLowerCase(), value: wid.textWidget });
          metadata.push({ key: design.widget_fieldID.toLowerCase(), value: wid.doc });
        }
        if (wid.type.includes('DATE')) {
          metadata.push({ key: design.widget_fieldID.toLowerCase(), value: new Date(wid.date).toLocaleString() });
          metadata.push({ key: design.widget_fieldID.toLowerCase(), value: wid.doc });
        }
      }

      if (
        wid.type.includes('SIGNATURE') &&
        wid.imagePath &&
        !metadata.find((f) => f.key === 'firma_imagen') &&
        this.operationType !== AvailableOperationTypes.SIGBIO
      ) {
        metadata.push({ key: 'firma_imagen', value: wid.imagePath.replace('data:image/jpg;base64,', '') });
      }
    });

    if (
      this.firmaImagen &&
      !metadata.find((f) => f.key === 'firma_imagen') &&
      this.operationType !== AvailableOperationTypes.SIGBIO
    ) {
      metadata.push({ key: 'firma_imagen', value: this.firmaImagen });
    }

    if (this.isDynSig) {
      metadata.push({ key: 'SIG_TYPE', value: this.operationType });
    }

    switch (this.operationType) {
      case AvailableOperationTypes.RVDOTP:
        metadata.push({ key: 'otp', value: this._finishProService.otpCode });
        metadata.push({ key: 'nif', value: this._finishProService.receiverNIF });
        break;
      case AvailableOperationTypes.SIG:
      case AvailableOperationTypes.SIGQSCD:
        this.metadataCert?.forEach((metadataArr) => {
          metadata.push({ key: metadataArr?.key, value: metadataArr?.value });
        });
        break;
      case AvailableOperationTypes.SIGBIO:
        metadata.push({ key: 'pressureDeviceSigBio', value: this._finishProService.pressureDeviceSigBio });

        if (this.signsSIGBIO) {
          for (let sign of this.signsSIGBIO) {
            metadata.push({ key: sign.idDocument, value: sign.data.replace('data:image/jpg;base64,', '') });
          }
        }
        break;
      default:
        break;
    }

    if (this._finishProService.attachedDocs.length) {
      metadata.push({
        key: 'docsClient',
        value: this._encoder.stringToB64(JSON.stringify(this._finishProService.attachedDocs)),
      });
    }

    if (this.latitude && this.longitude) {
      metadata.push({ key: 'latitude', value: this.latitude });
      metadata.push({ key: 'longitude', value: this.longitude });
    }

    return metadata;
  }

  startSignProccess(): void {
    if (this._finishProService.hasCustomFields && !this.hasSavedCustomFields) {
      this.validateCustomFields();
      return;
    } else {
      if (this.inputList?.length > 0) {
        const pdfArr = this._pdfViewerService.pdfDocumentManager?.pageManagerList ?? [];
        if (pdfArr.length > 0) {
          this.pageManagerArray = pdfArr.sort(this.toSortedPages);
          const page = this.pageManagerArray.find((p) => p.pageNumber === this.page);
          this.handlePageManagerAcrobatFields(page);
        }

        if (!this.hasRequriredCustomFields) {
          this._message.showError(this._translate.instant('finish_dialog_sign_required'));
          return;
        }
        this.sign();
      } else {
        this.sign();
      }
    }
  }

  async sign(): Promise<void> {
    const { ACEP, SIGBIO, SIG, SIGQSCD, RVDOTP } = AvailableOperationTypes;
    const isSimpleSignature = this.operationType === ACEP;
    const isBiometricSignature = this.operationType === SIGBIO;
    const isSignatureWithCertificate = [SIG, SIGQSCD].includes(this.operationType);
    const hasEmptyInputs = this.hasEmptyValueInputs();
    let isWidgetOnlyText: boolean = false;
    let isValidForm: boolean = true;

    this.addOperationMetadata();

    if (this._finishProService.validateFormDoc === 1 && this.hasGenerateFormDoc && !this.isSignatureReady) {
      isValidForm = await this.validateFormDocumentSuez();
    }


    if (!isValidForm) {
      return;
    }
    this._finishProService.metaDataOperation = this.metaDataOperation;
    if (this._finishProService.operationDetailResponse?.widgetOperation?.length) {
      isWidgetOnlyText = true;
      for (const widget of this._finishProService.operationDetailResponse?.widgetOperation) {
        if (JSON.parse(widget.design).signText || JSON.parse(widget.design).onlySign) {
          isWidgetOnlyText = false;
        }
      }
    }
    const hasWidgets = !!this._finishProService.operationDetailResponse?.widgetOperation?.length && !isWidgetOnlyText;

    if (
      (((isSimpleSignature && hasWidgets && !this.firmaImagen) || isBiometricSignature) && !this.isSignatureReady) ||
      (isSignatureWithCertificate && !this.metadataCert?.length)
    ) {
      this.finishAfterSign = true;
      this.openSignComponent('widget_1');
      return;
    }

    if (this.operationType === RVDOTP) {
      const dialog = this._dialog.open(AccessCodeComponent, {
        disableClose: true,
        width: '500px',
        hasBackdrop: false,
      });
      dialog.afterClosed().subscribe((result: { validated: boolean }) => {
        if (!result?.validated) {
          this.isOperationFinished = false;
        }
      });
      dialog.componentInstance.errorOTP.subscribe((result) => {
        if (result == 'error') {
          dialog.updatePosition({ top: '250px' });
        }
      });
      dialog.componentInstance.addOTP.subscribe((result: { validated: boolean }) => {
        if (!result?.validated) return;
        if (hasWidgets && !this.isSignatureReady) {
          this.finishAfterSign = true;
          dialog.updatePosition({ top: '-2000px' });
          this.openSignComponent('widget_1');
          return;
        }
        if (result?.validated) {
          this.addOperationMetadata();
          this.signOperation();
        }
      });
    } else {
      this.signOperation();
    }
  }

  hasEmptyValueInputs(): boolean {
    if (this.inputList?.length > 0) {
      for (const input of this.inputList) {
        if (!this.hasMetadataValue(input.value)) {
          return true;
        }
      }
    }

    return false;
  }

  hasMetadataValue(value: any): boolean {
    if (!value || value.length === 0) {
      return false;
    }

    if (Array.isArray(value)) {
      for (const element of value) {
        if (element.trim() === '') {
          return false;
        }
      }
    }

    return true;
  }

  async signOperation(): Promise<void> {
    this.isOperationFinished = true;
    document.getElementById('viewer').style.pointerEvents = 'none';

    try {
      const customFields: CustomMetadataOperation = {
        key: 'CustomFields',
        value: this.hasSavedCustomFields,
      };
      this.hasSavedCustomFields
        ? this.metaDataOperation.push(customFields, ...this.customFieldsValue)
        : this.metaDataOperation.push(customFields);
      await this._finishProService.putFinishOperation(true, this.metaDataOperation);
    } catch (e) {
      this.isOperationFinished = false;
      console.log(e);
    }

    if (this.operationType === AvailableOperationTypes.RVDOTP && this._finishProService.errorCodeRVDOTP) {
      this._message.showError(this._finishProService.errorCodeRVDOTP);
      this.isOperationFinished = false;
    } else {
      this._getRoute();
    }
    document.getElementById('viewer').style.pointerEvents = 'all';
  }

  async validateFormDocumentSuez(): Promise<boolean> {
    try {
      const response = await this._operation
        .operationPutValidateFormDocument(
          this._finishProService.operationId,
          this.metaDataOperation,
          this._profile.getPublicToken()
        )
        .toPromise();
      return response.data;
    } catch (e) {
      this.isOperationFinished = false;
      this.addMessageError(e);
      return false;
    }
  }

  async validateFormDocument(): Promise<boolean> {
    const confirmDialog = this._dialog.open(DialogConfirmComponent, {
      width: '376px',
      data: {
        subtitle: this._translate.instant('finish_dialog_sign'),
        buttonAccept: this._translate.instant('finish_confirm_text'),
        buttonCancel: this._translate.instant('finish_cancel_text'),
      },
    });
    const response = await confirmDialog.afterClosed().toPromise();

    return response;
  }

  changeValue(event: any, index: number, type: string): void {
    if (type === 'checkbox') {
      this.updateCheckbox(event, index);
    } else {
      this.updateRadioOrOther(event);
    }

    this.setInputListDocument(index);
  }

  private updateCheckbox(event: any, index: number): void {
    const checked = event.target.checked;
    this.inputList[index].value = checked ? 'On' : '';
    this.inputList[index].checked = checked;
  }

  private updateRadioOrOther(event: any): void {
    const name = event.target.name;
    const id = event.target.id;
    const checked = event.target.checked;
    this.inputName = name;

    for (let i = 0; i < this.inputList.length; i++) {
      const item = this.inputList[i];

      const isSameInput = name === item.name && id === item.id;
      const isOtherSameName = name === item.name && id !== item.id;

      if (isSameInput && checked) {
        item.value = item.name.startsWith('SEL_RDB') ? item.buttonValue : 'Off';
      } else if (isOtherSameName) {
        item.value = null;
      }
    }
  }

  setInputListDocument(indexInput: number = null): void {
    const pdfArr = this._pdfViewerService.pdfDocumentManager?.pageManagerList ?? [];
    if (pdfArr.length > 0) {
      this.pageManagerArray = pdfArr.sort(this.toSortedPages);
      const page = this.pageManagerArray.find((p) => p.pageNumber === this.page);
      this.handlePageManagerAcrobatFieldsStatus(page, indexInput);
    }
    const index = this.inputListByDocument.findIndex((f) => f.idDocument === this.idDocument);
    if (index === -1) {
      this.inputListByDocument.push({ idDocument: this.idDocument, data: this.inputList });
    } else {
      this.inputListByDocument[index].data = this.inputList;
    }
  }

  validateCustomFields(): void {
    this.isOperationFinished = false;
    const dialog = this._dialog.open(DialogCustomFieldsComponent, {
      data: this._finishProService.operationDetailResponse.CustomFields,
      width: '32rem',
      disableClose: true,
    });

    dialog
      .afterClosed()
      .subscribe((data: { result: boolean; customFields: CustomFiedlsType<string | boolean | Date>[] }) => {
        if (data?.result) {
          this.isOperationFinished = true;
          this.hasSavedCustomFields = true;
          this.customFieldsValue = data.customFields;
          this.sign();
        }
      });
  }

  private _getRoute(): void {
    const operationId = this._finishProService.operationId;
    const hasNextOperation = !!operationId;

    if (hasNextOperation) {
      this._finishProService.operationRequest.hasFinishCircuit = true;
      this._finishProService.operationRequest.idDocument = null;
      this._finishProService.operationRequest.documentList = null;
      this._finishProService.documentsReaded = [];
    }

    const route = this._finishProService.getRoutePath();
    const path = hasNextOperation ? `../${operationId}/${route}` : route;

    const CUSTOM_TIMEOUT: number = 500;
    setTimeout(() => this._router.navigate([path], { relativeTo: this._route.parent }), CUSTOM_TIMEOUT);
  }

  checkButtonDisabled(): boolean {
    return this.isOperationFinished || !this.termsAccepted || !this.allDocumentsReaded;
  }

  reject(): void {
    const d = this._dialog.open(ConfirmModalComponent, {
      width: '350px',
    });
    const sub = d.afterClosed().subscribe(async (result) => {
      if (result?.option) {
        this.showLoaderRejectBegin = true;
        document.getElementById('buttons-actions').style.pointerEvents = 'none';

        const metadata: CustomMetadataOperation[] = [];
        metadata.push({ key: 'privacyPolicyAccepted', value: true });
        metadata.push({ key: 'observations', value: result?.value });
        metadata.push({ key: 'rejectOption', value: 'REVISAR' });

        await this._finishProService.putFinishOperation(false, metadata, false);

        this._router.navigate([Routes.DASHBOARD]);
      }

      this.showLoaderRejectBegin = false;
      document.getElementById('buttons-actions').style.pointerEvents = 'all';
      sub.unsubscribe();
    });
  }

  checkDocuments(): void {
    const documents = this._finishProService.mainDocs;
    documents?.forEach((doc: IvCertCircuitDocumentP) => {
      this._finishProService.documentsReaded.push({ idDocument: doc.idDocument, readed: false, loaded: false });
    });
  }

  changePage(add: boolean = false): void {
    this.viewHasBeenChecked = false;
    this.resizeInputs();

    if (this.page) {
      this.page = parseInt(this.page.toString());

      if (add && this.page < this.trueTotalPages) {
        this.page += 1;
      } else if (this.page > 1) {
        this.page -= 1;
      }
    } else {
      this.page = 1;
    }

    this.prevPageBtn = this.page > 1 ? false : true;
    this.nextPageBtn = this.page === this.trueTotalPages ? true : false;
    if (this._finishProService.readAllDoc === 1) {
      this.validatorSinglePage();
    }
  }

  getLocation(): void {
    this._locationService.getLocation().then(
      (res) => {
        this.latitude = res.lat;
        this.longitude = res.lng;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  resizeInputs(): void {
    const element = document.getElementById('divBoard_1');
    if (element) {
      const size = element.getBoundingClientRect();
      this.realHeightPage = size.height;
      this.realWidthPage = size.width;
      this.ratioHeight = this.realHeightPage / this.defaultHeightPage;
      this.ratioWidth = this.realWidthPage / this.defaultWidthPage;
      if (this.pageCustomAnnotations.length > 0) {
        this.inputList.forEach((input, index) => {
          (input.height =
            (this.pageCustomAnnotations[index]['b'][1] - this.pageCustomAnnotations[index]['b'][3] + 2 * 4) *
            this.ratioHeight),
            (input.width =
              (this.pageCustomAnnotations[index]['b'][2] - this.pageCustomAnnotations[index]['b'][0] + 2 * 4) *
              this.ratioWidth);
        });
      }
    }
  }

  createInputList(elements: PageCustomAnnotations[]): void {
    for (let i = 0; i < elements.length; i++) {
      if (elements[i]['a'].rect) {
        const newTop = elements[i]['b'][1] - (elements[i]['b'][1] - elements[i]['b'][3]);
        const styles = {
          margin: 0,
          padding: 0,
          top: newTop * 1.45 * this.ratioHeight,
          left: elements[i]['b'][0] * 1.44 * this.ratioWidth,
          height: (elements[i]['b'][1] - elements[i]['b'][3] + 2 * 4) * this.ratioHeight,
          width: (elements[i]['b'][2] - elements[i]['b'][0] + 2 * 4) * this.ratioWidth,
        };

        const input = {
          type: elements[i]['a'].checkBox ? 'checkbox' : elements[i]['a'].radioButton ? 'radio' : 'text',
          page: elements[i]['c'].pageNumber,
          name: elements[i]['a'].fieldName,
          value: elements[i]['a'].fieldValue,
          id: elements[i]['a'].id,
          checkbox: elements[i]['a'].checkBox,
          radioButton: elements[i]['a'].radioButton,
          position: styles,
          readonly: elements[i]['a'].readOnly,
          fieldValue: '',
          checked: true,
          buttonValue: elements[i]['a'].buttonValue,
          error: false,
          flags: elements[i]['a'].fieldFlags,
        };
        if (Array.isArray(input.value)) {
          input.value = input.value[0];
        }
        if (input.type === 'radio') {
          if (input.name?.startsWith('SEL_RDB')) {
            if (input.value !== input.buttonValue) {
              input.value = '';
            }
          } else if (input.value !== '' && input.buttonValue !== '') {
            if (input.value === input.buttonValue) {
              input.value = 'Off';
            } else {
              input.value = '';
            }
          }
        }

        if (input.type === 'checkbox' && input.checkbox) {
          if (input.name?.startsWith('SEL_CHK')) {
            input.value = input.fieldValue === 'On' ? 'On' : '0';
            input.checked = input.fieldValue ? true : false;
          } else {
            input.checked = input.value === 'On' || input.value === 'X' || input.value === 'Sí' ? true : false;
          }
        }

        if (input.type === 'text') {
          if (input.position.width > 100 && input.position.width <= 250) {
            input.position.width = input.position.width * 1.3;
          } else if (input.position.width > 250 && input.position.width <= 400) {
            input.position.width = input.position.width * 1.4;
          } else if (input.position.width > 400 && input.position.width <= 600) {
            input.position.width = input.position.width * 1.5;
          } else if (input.position.width > 600) {
            input.position.width = input.position.width * 1.6;
          }
        }

        const hasInput = this.inputList.find((f) => f.id === input.id);
        if (!hasInput) {
          this.inputList.push(input);
        }

        if (this.documents.length > 1) {
          const data = this.inputListByDocument.find((f) => f.idDocument === this.idDocument)?.data;
          if (data) {
            this.inputList = data;
          }
        }
      }
    }
    let hash = {};
    this.inputList = this.inputList.filter((o) => (hash[o.id] ? false : (hash[o.id] = true)));
  }

  getInputPosition(input: any): any {
    const divboard = document
      .getElementById(!this.isSinglePage ? `divBoard_${input.page}` : 'divBoard_1')
      ?.getBoundingClientRect();
    return {
      top: `${(divboard?.width * input.position.top) / this.initialWidthDocument}px`,
      left: `${(divboard?.width * input.position.left) / this.initialWidthDocument}px`,
      height: `${(divboard?.width * input.position.height) / this.initialWidthDocument}px`,
      width: `${(divboard?.width * input.position.width) / this.initialWidthDocument}px`,
      padding: `${input.position.padding}px`,
      margin: `${input.position.margin}px`,
      position: 'absolute',
      zIndex: '99',
      borderColor: input.error ? 'red' : '',
      outline: input.error ? 'auto red' : '',
    };
  }

  changeTerms(checked: boolean): void {
    this.termsAccepted = checked;
    this._finishProService.termsAccepted = this.termsAccepted;
  }

  openTerms(): void {
    this._user.userGetRegisterConditions('tyc', this._profile.getPublicToken()).then(
      (response: IvCertGenericResponseRegisterConditions) => {
        if (response.data.content) {
          this.loadPDF(response.data);
        } else {
          window.open('https://www.signaturit.com/privacy-policy/');
        }
      },
      (error) => {
        console.log(error);
        window.open('https://www.signaturit.com/privacy-policy/');
      }
    );
  }

  loadPDF(registerConditions: RegisterConditions): void {
    this._encoder.b64toBlob(registerConditions.content).then(async (blob) => {
      const pdfUrl = URL.createObjectURL(blob);
      // Abrir el PDF en una nueva pestaña
      window.open(pdfUrl, '_blank');
    });
  }

  getSelectedDoc(event: string): void {
    this.selectedDoc = event;
  }

  downloadDocuments(): void {
    this.isOperationFinished = true;
    this.documentsHeader.downloadDocuments(1);
  }

  addMessageError(message?: HttpErrorResponse): void {
    this._notification.activeNotif(DisplayState.ERROR);
    if (message?.error?.error?.message.includes(codeViewerErrorsEnum.err86)) {
      this.notifMessage = this._translate.instant('signaturit_pro.document.error_validate_86');
    } else {
      this.notifMessage = `${message?.error?.error?.code}: ${message?.error?.error?.message}`;
    }
    document
      .getElementById('document-header-content')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  }

  getConfigTerms(): void {
    if (localStorage.getItem('terms')) {
      this.termsAccepted = true;
      localStorage.removeItem('terms');
    }
  }
}
